import { STAGES } from './enums.js';
export const NO_STAGE_FILTER = { mode: 'invests', stages: [] };
/** The stages in the vocabulary's order, with all of them folded into "Every stage". */
export function normalisedStages(stages) {
    const picked = STAGES.filter((stage) => stages.includes(stage));
    return picked.length === STAGES.length ? [] : picked;
}
/** One change from the dialog: another mode (the picked stages stay), or another set of stages. */
export function changeStageFilter(state, change) {
    return {
        mode: change.mode ?? state.mode,
        stages: change.stages === undefined ? state.stages : normalisedStages(change.stages),
    };
}
/** Whether the filter narrows anything, which is what a chip and Clear all ask. */
export function stageFilterActive(state) {
    return state.mode === 'leads' || state.stages.length > 0;
}
/**
 * What the filter asks of a fund's or candidate's stages, or null for no filter.
 * "Leads at" with every stage left open asks for all of them: any one will do.
 */
export function stageFilterWants(state) {
    if (!stageFilterActive(state))
        return null;
    return {
        kind: state.mode,
        stages: state.stages.length === 0 ? STAGES : state.stages,
    };
}
/** One chip per picked stage, or a single chip for "leads at any stage". */
export function stageFilterChipStages(state) {
    if (state.stages.length > 0)
        return [...state.stages];
    return state.mode === 'leads' ? [null] : [];
}
/** Takes one stage chip away; the last one standing takes the whole filter with it. */
export function removeStageChip(state, stage) {
    const rest = stage === null ? [] : state.stages.filter((candidate) => candidate !== stage);
    return rest.length === 0 ? NO_STAGE_FILTER : { mode: state.mode, stages: rest };
}
//# sourceMappingURL=stageFilter.js.map